import React from "react";
import PropTypes from "prop-types";

import { useFeatures } from "components/FeatureFlag";

import { ConditionsGroupView } from "..";

function TaskConditionsGroupView({
  taskGroup,
  children,
  onTaskConfigChange,
  onTaskOrderModified,
  ...props
}) {
  const isConditionalLogicEnabled = useFeatures("conditional-logic");

  if (!taskGroup?.conditions?.length)
    return <React.Fragment>{children([taskGroup])}</React.Fragment>;

  // Due to the maintenance of both legacy and new task conditions, a user without access to the feature flag can
  // have task with the new conditions group. However, it the component should render only the legacy task condition.
  if (taskGroup?.task && !isConditionalLogicEnabled)
    return <React.Fragment>{children(taskGroup.task)}</React.Fragment>;

  return (
    <ConditionsGroupView
      conditionsGroupId={taskGroup?.id}
      conditions={taskGroup?.conditions}
      items={taskGroup?.task}
      onConfigChange={onTaskConfigChange}
      onOrderModified={onTaskOrderModified}
      {...props}
    >
      {(args) => {
        return children(args);
      }}
    </ConditionsGroupView>
  );
}

TaskConditionsGroupView.propTypes = {
  taskGroup: PropTypes.oneOfType([
    PropTypes.shape({
      conditions: PropTypes.array,
      task: PropTypes.array,
    }),
    PropTypes.object,
  ]),
  children: PropTypes.func,
  onTaskConfigChange: PropTypes.func.isRequired,
  onTaskOrderModified: PropTypes.func.isRequired,
};

TaskConditionsGroupView.defaultProps = {
  children: () => {},
  taskGroup: null,
};

export default TaskConditionsGroupView;
